<div class="flex flex-col gap-4">
  <xemex-card [title]="'alarmsPage.settings.alarmTypes.title' | translate">
    <div class="flex flex-col gap-4">
      <p class="text-sm text-text-secondary">
        {{ 'alarmsPage.settings.alarmTypes.description' | translate }}
      </p>

      @if (loadError()) {
        <div class="flex items-center gap-2 rounded-xl bg-status-error p-3 text-error">
          <mat-icon>error_outline</mat-icon>
          <span>{{ 'alarmsPage.settings.alarmTypes.loadError' | translate }}</span>
        </div>
      }

      <xemex-table
        [data]="alarmTypes()"
        [columns]="columns"
        [loading]="loading()"
        [pageable]="true"
        [actionsLabel]="'alarmsPage.settings.alarmTypes.columns.overrides'"
        (toggleChange)="onToggleChange($event)"
        (selectChange)="onSelectChange($event)"
      >
        <ng-template #actionsCell let-row>
          @if (row.configurable) {
            <button mat-button color="primary" type="button" (click)="openDeviceOverrides(row)">
              <mat-icon>tune</mat-icon>
              @if (row.deviceOverrideCount) {
                {{
                  (row.deviceOverrideCount === 1
                    ? 'alarmsPage.settings.alarmTypes.deviceCount'
                    : 'alarmsPage.settings.alarmTypes.deviceCountPlural'
                  ) | translate: { count: row.deviceOverrideCount }
                }}
              } @else {
                {{ 'alarmsPage.settings.alarmTypes.noOverrides' | translate }}
              }
            </button>
          } @else {
            <span class="text-sm text-text-muted">{{
              'alarmsPage.settings.alarmTypes.noOverridesAllowed' | translate
            }}</span>
          }
        </ng-template>
      </xemex-table>
    </div>
  </xemex-card>

  <xemex-card [title]="'alarmsPage.settings.recipients.title' | translate">
    <div class="flex flex-col gap-4">
      <p class="text-sm text-text-secondary">
        {{
          'alarmsPage.settings.recipients.description'
            | translate: { enabled: emailEnabledCount(), total: alarmTypes().length }
        }}
      </p>

      <div class="flex flex-col divide-y divide-border-subtle">
        @for (recipient of recipients(); track recipient.id) {
          <xemex-list-row
            icon="person"
            [title]="
              recipient.name ??
              (partnerUsersComplete()
                ? ('alarmsPage.settings.recipients.unknownUser' | translate)
                : recipient.id)
            "
          >
            @if (recipient.valid) {
              <div class="text-xs text-text-secondary truncate">{{ recipient.email }}</div>
            } @else {
              <xemex-tag
                state="error"
                [label]="'alarmsPage.settings.recipients.invalid' | translate"
              />
            }
            <button
              listRowActions
              mat-icon-button
              (click)="removeRecipient(recipient)"
              [title]="'alarmsPage.settings.recipients.remove' | translate"
            >
              <mat-icon>close</mat-icon>
            </button>
          </xemex-list-row>
        } @empty {
          <xemex-no-items-found
            [compact]="true"
            [message]="'alarmsPage.settings.recipients.empty' | translate"
          />
        }
      </div>

      <xemex-filled-button icon="add" class="self-start" (click)="openAddRecipients()">
        {{ 'alarmsPage.settings.recipients.add' | translate }}
      </xemex-filled-button>
    </div>
  </xemex-card>

  @if (hasUnsavedChanges()) {
    <div
      class="sticky bottom-4 flex items-center justify-between gap-3 rounded-lg border border-amber-300 bg-status-warning p-3"
    >
      <div class="flex items-center gap-2 text-sm text-amber-800">
        <mat-icon class="shrink-0 text-amber-500 !text-[20px] !w-5 !h-5">warning</mat-icon>
        <span>{{ 'alarmsPage.settings.unsavedChanges.message' | translate }}</span>
      </div>
      <div class="flex items-center gap-2">
        <xemex-text-button (click)="discardChanges()" [disabled]="saving()">
          {{ 'alarmsPage.settings.unsavedChanges.discard' | translate }}
        </xemex-text-button>
        <xemex-filled-button
          (click)="saveChanges()"
          [disabled]="saving() || hasInvalidRecipients()"
        >
          {{ 'alarmsPage.settings.unsavedChanges.save' | translate }}
        </xemex-filled-button>
      </div>
    </div>
  }
</div>
